import { Directive, HostBinding, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';

import { BaseComponent } from '~components/abstractions/base.component';
import { BaseColumnModel } from '~components/dynamic-table/models/column-types/base-column.model';
import { Identifyable } from '~core/abstractions/identifyable';
import { OptionalType } from '~shared/core/types/optional.type';

@Directive()
export abstract class BaseColumnComponent<T extends Identifyable<TId>, TId = number> extends BaseComponent implements OnInit {
    @HostBinding('class') classes = 'w-full';

    @Input() columnModel!: BaseColumnModel;
    @Input() item!: T;
    @Input() formGroup?: FormGroup<{ [K in keyof T]: AbstractControl<any, any> }>;

    get control(): OptionalType<FormControl> {
        return this.columnModel.propertyName ? (this.formGroup?.get(this.columnModel.propertyName) as FormControl) : undefined;
    }

    ngOnInit(): void {
        if (this.columnModel.isDisabled && !!this.control) {
            this.control.disable();
        }

        // editable columns should always be full height
        if (this.columnModel.isEditable && !!this.control) {
            this.classes = 'w-full h-full';
        }
    }

    getItemValue(propertyName?: string): any {
        return !!this.columnModel.customFormatter
            ? this.columnModel.customFormatter(this.item, this.getValue(propertyName), propertyName)
            : this.getValue(propertyName);
    }

    isBold(propertyName?: string): boolean {
        return !!this.columnModel.isBold && this.columnModel.isBold(this.item, this.getValue(propertyName), propertyName);
    }

    private getValue(propertyName?: string): any {
        return !!propertyName && propertyName in this.item ? this.item[propertyName as keyof typeof this.item] : '';
    }
}
